import { escapeHtml } from "./collectBlocks";
import {
  isMeaningfulFontFamily,
  isMeaningfulFontSize,
  type RunMeta,
} from "../ooxml/textCore";

export function runToHtml(run: RunMeta): string {
  if (!run.text) return "";

  let html = escapeHtml(run.text);

  if (run.superscript) html = `<sup>${html}</sup>`;
  else if (run.subscript) html = `<sub>${html}</sub>`;

  if (run.strike) html = `<s>${html}</s>`;
  if (run.underline) html = `<u>${html}</u>`;
  if (run.italic) html = `<em>${html}</em>`;
  if (run.bold) html = `<strong>${html}</strong>`;

  const styles: string[] = [];
  if (isMeaningfulFontSize(run.fontSizePt)) {
    styles.push(`font-size: ${run.fontSizePt}pt`);
  }
  if (isMeaningfulFontFamily(run.fontFamily)) {
    styles.push(`font-family: '${run.fontFamily!.replace(/'/g, "")}'`);
  }
  if (run.allCaps) styles.push("text-transform: uppercase");

  if (styles.length) {
    html = `<span style="${styles.join("; ")}">${html}</span>`;
  }

  return html;
}

export function runsToHtml(runs: RunMeta[]): string {
  return runs.map(runToHtml).join("");
}

export function normalizeComparableText(text: string): string {
  return text.replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
}

export function blockHasInlineFormatting(el: HTMLElement): boolean {
  return !!el.querySelector(
    "strong, b, em, i, u, s, strike, sup, sub, span[style*=\"font-size\"], span[style*=\"font-family\"]",
  );
}

export function textsCompatible(blockText: string, runsText: string): boolean {
  const a = normalizeComparableText(blockText);
  const b = normalizeComparableText(runsText);
  if (!a || !b) return false;
  if (a === b) return true;
  return a.endsWith(b) || b.endsWith(a);
}
